import { Group, Paper, Stack } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { JournalCardContent } from '@/module/Author/Paper/components/JournalCardContent';
import { PublicationCardIdentifiers } from '@/module/Author/Publication/components/PublicationCardIdentifiers';
import { PublicationTitle } from '@/module/Author/Publication/components/PublicationTitle';

import {
  BdiList,
  LanguagePill,
  NoOfAuthors,
  PublishedAtText,
  WosIndexAs,
  WosIndexAt,
  WosIndexList,
} from '@feature/utils';

import { Article } from './../../model/ArticleTypes';
import classes from './ArticleCard.module.css';

export interface ArticleCardProps {
  article: Article;
  to?: string;
  onClick?: () => void;
}

export function ArticleCard({ article, to, onClick }: ArticleCardProps) {
  const { publishedAt, authors, language, bdis, identifiers, wosIndexingYear, type, wosIndexes } = article;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      onClick={onClick}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <PublicationTitle
          pre={<WosIndexAs type={type} />}
          publication={article}
        />
        <Group>
          <JournalCardContent paper={article} />
          <BdiList bdis={bdis} />
        </Group>
        <WosIndexList indexes={wosIndexes} />
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <WosIndexAt year={wosIndexingYear} />
          <NoOfAuthors authors={authors} />
        </Group>
        <Group>
          <LanguagePill language={language} />
          {identifiers && <PublicationCardIdentifiers identifiers={identifiers} />}
        </Group>
      </Stack>
    </Paper>
  );
}
